import React from "react";
import styles from "./portrait.module.css";
import { portraitFaces } from "../../CONTENT/portraitFaces";

// Frame presets: aspect = height / width; faceHeight and faceY are fractions
// of the frame height where every face should land.
const SHAPES = {
  arch: { aspect: 4 / 3, faceHeight: 0.36, faceY: 0.4 },
  tall: { aspect: 5 / 4, faceHeight: 0.34, faceY: 0.36 },
  circle: { aspect: 1, faceHeight: 0.5, faceY: 0.46 },
};

const clamp = (v, lo, hi) => Math.min(Math.max(v, lo), hi);

// Scales and offsets the photo (in frame-width units) so the detected face is
// the target size and position, without ever exposing the frame behind it.
const placement = (face, shape) => {
  const { aspect: A, faceHeight, faceY } = SHAPES[shape];
  const { w, h, fx, fy, fh, openTop } = face;
  const s = Math.max((faceHeight * A) / (fh * h), 1 / w, A / h);
  const rw = w * s;
  const rh = h * s;
  const x = clamp(0.5 - fx * w * s, 1 - rw, 0);
  // a white strip above the head blends into the frame, so it may show
  const y = clamp(faceY * A - fy * h * s, A - rh, openTop ? Infinity : 0);
  return {
    width: `${rw * 100}%`,
    left: `${x * 100}%`,
    top: `${(y / A) * 100}%`,
  };
};

const Portrait = ({ src, alt, name, shape = "arch", className, loading = "lazy" }) => {
  const face = portraitFaces[name];
  const frameStyle = { aspectRatio: `1 / ${SHAPES[shape].aspect}` };
  return (
    <div className={`${styles.frame} ${styles[shape]} ${className || ""}`} style={frameStyle}>
      {face ? (
        <img
          src={src}
          alt={alt}
          loading={loading}
          decoding="async"
          className={styles.placed}
          style={placement(face, shape)}
        />
      ) : (
        <img src={src} alt={alt} loading={loading} decoding="async" className={styles.fallback} />
      )}
    </div>
  );
};

export default Portrait;
